/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelTransactionHistoryItem } from './FuelTransactionHistoryItem';
import {
    FuelTransactionHistoryItemFromJSON,
    FuelTransactionHistoryItemFromJSONTyped,
    FuelTransactionHistoryItemToJSON,
    FuelTransactionHistoryItemToJSONTyped,
} from './FuelTransactionHistoryItem';
import type { FuelTransactionHistoryResponsePagination } from './FuelTransactionHistoryResponsePagination';
import {
    FuelTransactionHistoryResponsePaginationFromJSON,
    FuelTransactionHistoryResponsePaginationFromJSONTyped,
    FuelTransactionHistoryResponsePaginationToJSON,
    FuelTransactionHistoryResponsePaginationToJSONTyped,
} from './FuelTransactionHistoryResponsePagination';

/**
 * 
 * @export
 * @interface FuelTransactionHistoryResponse
 */
export interface FuelTransactionHistoryResponse {
    /**
     * 
     * @type {Array<FuelTransactionHistoryItem>}
     * @memberof FuelTransactionHistoryResponse
     */
    transactions?: Array<FuelTransactionHistoryItem>;
    /**
     * 
     * @type {FuelTransactionHistoryResponsePagination}
     * @memberof FuelTransactionHistoryResponse
     */
    pagination?: FuelTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof FuelTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof FuelTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof FuelTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the FuelTransactionHistoryResponse interface.
 */
export function instanceOfFuelTransactionHistoryResponse(value: object): value is FuelTransactionHistoryResponse {
    return true;
}

export function FuelTransactionHistoryResponseFromJSON(json: any): FuelTransactionHistoryResponse {
    return FuelTransactionHistoryResponseFromJSONTyped(json, false);
}

export function FuelTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(FuelTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : FuelTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function FuelTransactionHistoryResponseToJSON(json: any): FuelTransactionHistoryResponse {
    return FuelTransactionHistoryResponseToJSONTyped(json, false);
}

export function FuelTransactionHistoryResponseToJSONTyped(value?: FuelTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(FuelTransactionHistoryItemToJSON)),
        'pagination': FuelTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

